// src/hooks/useAuthCodes.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/apiService';

export const authCodeKeys = {
  all: ['authCodes'],
  current: () => [...authCodeKeys.all, 'current'],
};

// Hook do pobierania aktualnego kodu autoryzacji - z dynamicznym czasem ważności
export function useAuthCode(options = {}) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: authCodeKeys.current(),
    queryFn: apiService.getAuthCode,
    // Domyślne ustawienia
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    // Długi domyślny staleTime
    staleTime: 1000 * 60 * 60, // 1 godzina - domyślnie
    // Po otrzymaniu odpowiedzi od API
    onSuccess: (data) => {
      if (data?.expires_at) {
        // Oblicz ile czasu pozostało do wygaśnięcia
        const expiryTime = new Date(data.expires_at).getTime();
        const currentTime = Date.now();
        const timeUntilExpiry = expiryTime - currentTime;
        
        if (timeUntilExpiry > 0) {
          // Jeśli kod jeszcze nie wygasł, zaplanuj unieważnienie zapytania
          // dokładnie w momencie wygaśnięcia (minus 1 sekunda dla bezpieczeństwa)
          setTimeout(() => {
            console.log('Auth code expired, invalidating query');
            queryClient.invalidateQueries({ queryKey: authCodeKeys.current() });
          }, timeUntilExpiry - 1000);
          
          // Można też zalogować informacje dla celów debugowania
          console.log(`Auth code valid for ${Math.round(timeUntilExpiry / 1000 / 60)} minutes`);
        } else {
          // Kod już wygasł, natychmiast unieważnij zapytanie
          console.log('Auth code already expired');
          queryClient.invalidateQueries({ queryKey: authCodeKeys.current() });
        }
      }
    },
    ...options,
  });
}

// Hook do generowania nowego kodu autoryzacji
export function useGenerateAuthCode() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: apiService.generateAuthCode,
    onSuccess: (data) => {
      // Po wygenerowaniu kodu zaktualizuj cache
      queryClient.setQueryData(authCodeKeys.current(), data);
    },
  });
}